import CONFIG from '@webclient/lib/const/user-specific-settings';
import { getDecodedToken } from '@webclient/lib/jwt';

import initializeUserSpecificSettingsAfterJWTTokenIsSet from '@webclient/state/middleware/app-settings/utils/initializeUserSpecificSettingsAfterJWTTokenIsSet';
import {
  initializedUserSpecificSettings,
  setBotByUserId,
  setCustomStyleByUserId,
  setResearchAdvancedTimeByUserId,
  setResponseLengthByUserId,
  setSearchModeByUserId,
  setSearchScopeByUserId,
  setUploadedToKnowledgeBaseByUserId,
  setUseCustomStyleByUserId,
  setVoiceAutoplayByUserId,
  setVoiceSpeedByUserId,
  setVoiceTypeByUserId,
  setVoiceZonosTtsByUserId,
} from '@webclient/state/slices/app-settings';
import { AppDispatch, RootType } from '@webclient/state/store';

import { Middleware } from 'redux';

const appSettingsMiddleware: Middleware = ({
  dispatch,
}: {
  getState: () => RootType;
  dispatch: AppDispatch;
}) => {
  return (next) => async (action) => {
    if (initializedUserSpecificSettings.match(action)) {
      const token = getDecodedToken(localStorage.getItem('token'));
      if (token) {
        const settings = initializeUserSpecificSettingsAfterJWTTokenIsSet(
          CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS,
        );

        if (!settings) {
          throw new Error('Failed to initialize user specific settings');
        }

        dispatch(
          setUploadedToKnowledgeBaseByUserId({
            userId: token.uuid,
            shouldSave:
              settings[token.uuid]?.shouldSaveUploadsToKnowledgeBase ??
              CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS[
                'shouldSaveUploadsToKnowledgeBase'
              ],
          }),
        );
        dispatch(
          setSearchScopeByUserId({
            userId: token.uuid,
            searchScope:
              settings[token.uuid]?.searchScope ??
              CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS['searchScope'],
          }),
        );
        dispatch(
          setCustomStyleByUserId({
            userId: token.uuid,
            customStyle:
              settings[token.uuid]?.customStyle ??
              CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS['customStyle'],
          }),
        );
        dispatch(
          setUseCustomStyleByUserId({
            userId: token.uuid,
            useCustomStyle:
              settings[token.uuid]?.useCustomStyle ??
              CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS['useCustomStyle'],
          }),
        );
        dispatch(
          setResponseLengthByUserId({
            userId: token.uuid,
            responseLength:
              settings[token.uuid]?.responseLength ??
              CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS['responseLength'],
          }),
        );
        dispatch(
          setSearchModeByUserId({
            userId: token.uuid,
            searchMode:
              settings[token.uuid]?.searchMode ??
              CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS['searchMode'],
          }),
        );
        dispatch(
          setResearchAdvancedTimeByUserId({
            userId: token.uuid,
            researchAdvancedTime:
              settings[token.uuid]?.researchAdvancedTime ??
              CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS['researchAdvancedTime'],
          }),
        );
        dispatch(
          setBotByUserId({
            userId: token.uuid,
            bot:
              settings[token.uuid]?.bot ??
              CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS['bot'],
          }),
        );
        dispatch(
          setVoiceTypeByUserId({
            userId: token.uuid,
            type:
              settings[token.uuid]?.voice.type ??
              CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS['voice']?.type,
          }),
        );
        dispatch(
          setVoiceSpeedByUserId({
            userId: token.uuid,
            speed:
              settings[token.uuid]?.voice.speed ??
              CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS['voice']?.speed,
          }),
        );
        dispatch(
          setVoiceAutoplayByUserId({
            userId: token.uuid,
            autoplay:
              settings[token.uuid]?.voice.autoplay ??
              CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS['voice']?.autoplay,
          }),
        );

        dispatch(
          setVoiceZonosTtsByUserId({
            userId: token.uuid,
            zonos:
              settings[token.uuid]?.voice.zonos ??
              CONFIG.DEFAULT_SPECIFIC_USER_SETTINGS['voice']?.zonos,
          }),
        );
      }
    }

    next(action);
  };
};

export default appSettingsMiddleware;
